import React, { CSSProperties } from "react";
import { getSeverityColor } from "../utils/overviewColors";

export type BadgeSeverity = "critical" | "warning" | "info" | "success";

interface StatusBadgeProps {
  severity: BadgeSeverity;
  children: React.ReactNode;
  className?: string;
  style?: CSSProperties;
}

export const StatusBadge: React.FC<StatusBadgeProps> = ({
  severity,
  children,
  className = "",
  style = {},
}) => {
  const colors = getSeverityColor(severity);

  const defaultStyle: CSSProperties = {
    backgroundColor: colors.bg,
    color: colors.text,
    padding: "2px 8px",
    borderRadius: "4px",
    fontSize: "11px",
    fontWeight: 600,
    textTransform: "capitalize",
    letterSpacing: "0.02em",
    display: "inline-block",
    ...style,
  };

  return (
    <span
      className={`alert-severity-badge alert-badge-${severity} ${className}`}
      style={defaultStyle}
    >
      {children}
    </span>
  );
};
